/**
 * Created by mgoria on 03/03/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FailedToReceiveSqsMessageException = undefined;

var _LogDriverException2 = require('./LogDriverException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when failed to receive sqs messages
 */
let FailedToReceiveSqsMessageException = exports.FailedToReceiveSqsMessageException = function (_LogDriverException) {
  _inherits(FailedToReceiveSqsMessageException, _LogDriverException);

  /**
   * @param {String} sqsQueueUrl
   * @param {Object} error
   */
  function FailedToReceiveSqsMessageException(sqsQueueUrl, error) {
    _classCallCheck(this, FailedToReceiveSqsMessageException);

    return _possibleConstructorReturn(this, (FailedToReceiveSqsMessageException.__proto__ || Object.getPrototypeOf(FailedToReceiveSqsMessageException)).call(this, `Failed to receive messages from "${sqsQueueUrl}" SQS queue. ${error}`));
  }

  return FailedToReceiveSqsMessageException;
}(_LogDriverException2.LogDriverException);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/Exception/FailedToReceiveSqsMessageException.js
// module id = 399
// module chunks = 0